import { appStateMock, href } from 'app/utils/test/constants';

export const AVATAR_SIZE = 52;
export const OPTIONS_SIZE = 50;

export const SONG_DRAG_EVENT_TYPE = 'SONG_DRAG';

export const TEST_STATES = {
  preloadedState: {
    ...appStateMock,
    auth: {
      ...appStateMock.auth,
      services: {
        ...appStateMock.auth.services,
        songs: {
          _links: {
            listSongs: href,
          },
        },
      },
    },
  },
};
